<template>
  <div class="total_content">
    <div class="tool_title">{{toolTitle}}</div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "extensionTool",
    props: {
      // 工具标题
      toolTitle: {
        type: String,
        required: true,
      },
    }
  }
</script>

<style scoped>
  .total_content{
    background-color: white;
  }

  .tool_title{
    width: 100%;
    border-bottom: 1px solid rgba(241, 244, 249, 1);
    font-weight: 600;
    color: black;
    text-align: start;
  }

  .tool_title:after{
    content:'';
    display: block;
    border-bottom:3px solid #ff7f17;
  }

  @media screen and (max-width: 1422px) {
    .total_content{
      width: 35rem;
      height: 28rem;
      border-radius: 1rem;
      margin: 1rem;
    }

    .tool_title{
      font-size: 1.8rem;
      padding: 1rem 0.9rem 0;
      height: 3.8rem;
    }

    .tool_title:after{
      width: 1.8rem;
      margin-left: 4rem;
    }
  }

  @media screen and (max-width: 1600px) and (min-width: 1422px) {
    .total_content{
      width: 35.3rem;
      height: 28rem;
      border-radius: 1rem;
      margin: 1rem;
    }

    .tool_title{
      font-size: 1.8rem;
      padding: 1rem 0.9rem 0;
      height: 3.8rem;
    }

    .tool_title:after{
      width: 1.8rem;
      margin-left: 4rem;
    }
  }

  @media screen and (min-width: 1600px){
    .total_content{
      width: 480px;
      height: 300px;
      border-radius: 10px;
      margin: 10px 13px;
    }

    .tool_title{
      font-size: 20px;
      padding: 12px 10px 0;
      height: 40px;
    }

    .tool_title:after{
      width: 20px;
      margin-left: 40px;
    }
  }
</style>
